import styled, { css } from "styled-components";

export const TravelSegmentDrawerList = styled.ul`
	display: flex;
	flex-direction: column;
	list-style: none;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const TravelSegmentDrawerListItem = styled.li<{ $isSelectable?: boolean }>`
	${({ $isSelectable }) =>
		$isSelectable &&
		css`
			cursor: pointer;
		`}
`;

export const TravelSegmentDrawerEmptyList = styled.li`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(4)};
`;
